import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { locationsActions } from 'features/locations';

const useLocations = () => {
  const dispatch = useDispatch();
  const getLocations = useCallback(({ offset, query }) => dispatch(locationsActions.getLocations({ offset, query })), [dispatch]);
  const getLocation = useCallback(id => dispatch(locationsActions.getLocation(id)), [dispatch]);
  const createLocation = useCallback(location => dispatch(locationsActions.createLocation(location)), [dispatch]);
  const updateLocation = useCallback(location => dispatch(locationsActions.updateLocation(location)), [dispatch]);
  const deleteLocation = useCallback(id => dispatch(locationsActions.deleteLocation(id)), [dispatch]);
  const clearLocalLocations = useCallback(() => dispatch(locationsActions.clearLocalLocations()), [dispatch]);
  const clearLocalActiveLocation = useCallback(() => dispatch(locationsActions.clearLocalActiveLocation()), [dispatch]);

  return {
    getLocations,
    getLocation,
    createLocation,
    updateLocation,
    deleteLocation,
    clearLocalLocations,
    clearLocalActiveLocation
  };
};

export default useLocations;